export const API_ENDPOINTS = {
  site: {
    updateSettings: '/api/site/update-settings',
    getUrls: '/api/site/get-urls',
  },
  payment: {
    connectProvider: '/api/payment/connect-provider',
    paymentAggregate: (metaSiteId: string) => `/api/payment/payment-aggregate/${metaSiteId}`,
  },
  postPurchase: {
    acceptPaymentsSetup: '/api/post-purchase/accept-payments-setup',
  },
  headless: {
    createHeadlessSite: '/api/create-headless-site',
    connectVibePlatform: '/api/headless/connect-vibe-platform',
  },
} as const;

export const TIME_BUDGETS = {
  short: 10000,
  medium: 20000,
  long: 40000,
  extended: 60000,
} as const;
